import { useMemo } from 'react';

import { Version } from '@/global/types/common.type';
import { useAppSelector } from '@/store/utils';

export interface BaseHookResult {
  error?: Error;
}

export function createVersionedHook<T extends BaseHookResult>(hooks: Record<Version, () => T>, hookName: string) {
  return function useVersionedHook(): T {
    const version = useAppSelector(state => state.app.nodeVersion);

    const hook = useMemo(() => {
      const selectedHook = hooks[version ?? 'v1'];

      if (!selectedHook) {
        throw new Error(`No implementation found for ${hookName} version ${version}`);
      }

      return selectedHook;
    }, [version]);

    try {
      return hook();
    } catch (error) {
      console.error(`Error in ${hookName} (${version}):`, error);
      return {
        error: error instanceof Error ? error : new Error('Unknown error'),
      } as T;
    }
  };
}
